"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCellContents = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _GroupedTableCell = require("./GroupedTableCell");
var _TableProps = require("../TableProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TableCellContents = _ref => {
  let {
    cell,
    row,
    isEditable,
    inlineEditing,
    onEdit,
    hookFormMethods
  } = _ref;
  if (cell.isPlaceholder) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\xA0");
  }
  if (cell.isGrouped) {
    return /*#__PURE__*/_react.default.createElement(_GroupedTableCell.GroupedTableCell, {
      cell: cell,
      row: row
    });
  }
  if (cell.isAggregated) {
    return cell.render('Aggregated');
  }
  return cell.render('Cell', {
    isEditable,
    inlineEditing,
    onEdit,
    cell,
    row,
    hookFormMethods
  });
};
exports.TableCellContents = TableCellContents;
TableCellContents.propTypes = {
  cell: _propTypes.default.shape(_TableProps.TableCellProps),
  row: _propTypes.default.shape(_TableProps.TableRowProps),
  isEditable: _propTypes.default.bool,
  inlineEditing: _propTypes.default.bool,
  onEdit: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  hookFormMethods: _propTypes.default.any
};